/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { useCallback, useRef } from 'react';

const useDebouncedCallback = (callback, delay = 500) => {
  const timeoutRef = useRef();

  return useCallback((...args) => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      callback(...args);
    }, delay);
  }, [callback, delay]);
};

export default useDebouncedCallback;
